"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartialProgressCallbacks = exports.createProgressHelper = void 0;
const common_1 = require("@finley-technologies/common");
/**
 * Helper to send progress updates to the client.
 * @param {number} numRows - the number of rows to process.
 * @param {ProgressCallBack} progressCallback - the callback to send progress updates to.
 * @returns {IProgressHelper} an object with a single method to update the progress.
 */
const createProgressHelper = ({ progressCallback, operation, numRows, }) => {
    // we will send progress updates every 4 seconds
    // or every 10% of the rows.
    const MaxProgressIntervalMS = 4 * 1000; // 4 seconds
    const MaxProgressIntervalRows = Math.round(numRows / 10);
    let lastUpdateMS = -1;
    let lastUpdateIndex = -1;
    return {
        updateProgress: async (index, message) => {
            if (progressCallback) {
                const currentTimeMS = Date.now();
                // check if its time to send another update.
                if (currentTimeMS > lastUpdateMS + MaxProgressIntervalMS ||
                    index > lastUpdateIndex + MaxProgressIntervalRows) {
                    lastUpdateMS = currentTimeMS;
                    lastUpdateIndex = index;
                    const progressPercent = (index / numRows) * 100;
                    await progressCallback(operation, message ?? `Processing ${index}/${numRows}`, progressPercent);
                }
            }
        },
    };
};
exports.createProgressHelper = createProgressHelper;
const makePartialProgressCallback = (progressCallback, startPercent, endPercent) => {
    return async (operation, message, progressPercent) => {
        if (progressCallback) {
            // check if its time to send another update.
            const mappedProgressPercent = (progressPercent * (endPercent - startPercent)) / 100 + startPercent;
            await progressCallback(operation, message, mappedProgressPercent);
        }
    };
};
const convertWeightsToPercentages = (weights) => {
    const totalWeight = weights.reduce((acc, weight) => acc + weight, 0);
    const percentages = weights.map((weight) => (weight / totalWeight) * 100);
    const sum = percentages.reduce((acc, percent) => acc + percent, 0);
    const diff = 100 - sum; // take care of any floating point errors.
    percentages[percentages.length - 1] += diff;
    return percentages;
};
// sometime a function need to split progress between sub tasks.
// this helper returns multiple progress callbacks that will send
// progress updates to the client. The progress will be mapped
// to the given percentage for each callback.
const createPartialProgressCallbacks = ({ progressCallback, weights, }) => {
    const percentages = convertWeightsToPercentages(weights);
    let startPercent = 0;
    return percentages.map((partialPercentage) => {
        (0, common_1.finleyAssert)(partialPercentage > 0, `Percent must be greater than 0: ${partialPercentage}`);
        const partialCallback = makePartialProgressCallback(progressCallback, startPercent, partialPercentage + startPercent);
        startPercent += partialPercentage;
        return partialCallback;
    });
};
exports.createPartialProgressCallbacks = createPartialProgressCallbacks;
//# sourceMappingURL=progressHelper.js.map